import styled, { css } from "styled-components";

const BottomBoard = styled.div`
  ${({ theme }) => css`
    border-radius: 2rem 2rem 0px 0px;
    background: ${theme.color.background.white};
    box-shadow: 0px -4px 30px 0px rgba(0, 0, 0, 0.05);

    position: fixed;
    bottom: 0;

    padding: 3rem 1.6rem;
  `}
`;

export default BottomBoard;
